export type GpsPayload =
  | { status: 'OK'; lat: number; lng: number; accuracy: number; capturedAt: string }
  | { status: 'PERMISSION_DENIED' | 'UNAVAILABLE' | 'TIMEOUT' | 'NOT_SUPPORTED' };

/**
 * Obtiene UNA posición puntual para asociarla a un fichaje. No se usa watchPosition: WulfTime no hace seguimiento.
 */
export function getPosition(timeoutMs = 15_000): Promise<GpsPayload> {
  return new Promise((resolve) => {
    if (!('geolocation' in navigator)) return resolve({ status: 'NOT_SUPPORTED' });
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ status: 'OK', lat: p.coords.latitude, lng: p.coords.longitude, accuracy: Math.round(p.coords.accuracy), capturedAt: new Date(p.timestamp).toISOString() }),
      (err) => resolve({ status: err.code === err.PERMISSION_DENIED ? 'PERMISSION_DENIED' : err.code === err.TIMEOUT ? 'TIMEOUT' : 'UNAVAILABLE' }),
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 10_000 },
    );
  });
}

export async function permissionState(): Promise<PermissionState | 'unsupported'> {
  try {
    const r = await navigator.permissions.query({ name: 'geolocation' as PermissionName });
    return r.state;
  } catch {
    return 'unsupported';
  }
}
